<template>
  <div class="overflow-y-auto" style="height: 55vh">
    <div class="d-flex align-center pb-5 px-1">
      <div class="cursor-pointer">
        <v-icon
          v-if="!FORNECEDORES_SELECIONADOS.length"
          color="#142454"
          v-text="'mdi-checkbox-blank-outline'"
          @click="FORNECEDORES_SELECIONADOS = fornecedores" />

        <v-icon
          v-else-if="FORNECEDORES_SELECIONADOS.length === fornecedores.length"
          color="#142454"
          v-text="'mdi-checkbox-marked'"
          @click="FORNECEDORES_SELECIONADOS = []" />

        <v-icon
          v-else
          color="#142454"
          v-text="'mdi-minus-box'"
          @click="FORNECEDORES_SELECIONADOS = fornecedores" />
      </div>

      <p
        class="ma-0 ml-2 text-gray font-12 font-weight-medium text-color-333333"
        v-text="'Selecionar todos'"
      />
    </div>

    <template v-for="(fornecedor, index) in fornecedores">
      <FornecedorPorCotar
        :item="fornecedor"
        :key="index"
        :fornecedores_seleionados="FORNECEDORES_SELECIONADOS"
        @selecionar="selecionarFornecedor"
      />
    </template>
  </div>
</template>

<script>
import FornecedorPorCotar from "./FornecedorPorCotar";
import {buscarFornecedoresCotacao} from "@/api/compras/MateriaPrima";
import {logout} from "@/helpers";

export default {
  name: "FornecedoresPorCotar",
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: Array,
      default: () => ([])
    },
    pedido: Object
  },
  components: {FornecedorPorCotar},
  data: () => ({
    fornecedores: []
  }),
  computed: {
    FORNECEDORES_SELECIONADOS: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        this.$emit('update:modelValue', valor)
      }
    }
  },
  mounted() {
    this.buscarFornecedoresPorCotar();
  },
  methods: {
    buscarFornecedoresPorCotar() {
      this.$store.dispatch('loading/addRequisicao',
        buscarFornecedoresCotacao(this.pedido.id)
          .then(fornecedores => {
            const callback = item => {
              item.expandido = false;
              item.id_pedido = this.pedido.id;
              item.categorias = [];
              return item;
            };
            this.fornecedores = fornecedores.map(callback)
          })
          .catch(logout)
      );
    },
    selecionarFornecedor(fornecedor) {
      const callback = item => item.id_fornecedor === fornecedor.id_fornecedor;
      const fornecedor_selecionado = this.FORNECEDORES_SELECIONADOS.find(callback);

      if (!fornecedor_selecionado) {
        this.FORNECEDORES_SELECIONADOS.push(fornecedor);
        return;
      }

      this.FORNECEDORES_SELECIONADOS = this.FORNECEDORES_SELECIONADOS.filter(item => !callback(item));
    }
  }
}
</script>

<style scoped>
</style>
